import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { setHasNoData } from "../Directory/directorySlice";

export const fetchRuleActionData = createAsyncThunk(
  "ruleActions/fetchRuleActionData",
  async ({ url, config }, { dispatch }) => {
    const response = await axios.get(url, config);
    const data = response.data.data;

    if (!data || data.length === 0) {
      dispatch(setHasNoData(true));
    } else {
      dispatch(setHasNoData(false));
    }
    return data;
  }
);

const initialState = {
  ruleActions: [],
  status: "idle",
  loading: true,
  error: null,
};

const ruleActionSlice = createSlice({
  name: "ruleActions",
  initialState,
  reducers: {
    addRuleAction: (state, action) => {
      state.ruleActions.push(action.payload);
    },

    updateRuleAction: (state, action) => {
      const { id, updatedData } = action.payload;
      const index = state.ruleActions.findIndex((action) => action.id === id);
      if (index !== -1) {
        state.ruleActions[index] = { ...updatedData };
      }
    },

    deleteRuleAction: (state, action) => {
      const id = action.payload;
      state.ruleActions = state.ruleActions.filter((action) => action.id !== id);
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchRuleActionData.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(fetchRuleActionData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.ruleActions = action.payload;
        state.loading = false;
      })
      .addCase(fetchRuleActionData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { addRuleAction, updateRuleAction, deleteRuleAction } = ruleActionSlice.actions;

export default ruleActionSlice.reducer;
